<template>
  <div class="h-screen w-full px-10 flex justify-center items-center">
    <div>
      <div v-if="isOverExaminationReceptionEnd">
        <p class="text-CLIENT_BL leading-5 md:text-xl text-center">申し訳ありません。</p>
        <p class="mt-8 text-CLIENT_BL leading-5 md:text-xl text-center">試験実施期間が終了しました。</p>
      </div>
      <div v-else>
        <p class="text-CLIENT_BL leading-5 text-xl md:text-3xl text-center">試験が終了しました。</p>
      </div>
      <button
        class="bg-green-600 block mx-auto mt-6 px-8 py-2 rounded text-blue-50 max-w-max shadow-sm hover:shadow-lg"
        type="button"
        @click="onClickCommentary()">
        解説ページへ
      </button>
      <p class="mt-10 text-CLIENT_BL md:text-xl text-center">他の種別の模試実施にお進みください。</p>
      <button
        class="block mx-auto mt-6 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
        @click="backToClientTop">
        TOPへ戻る
      </button>
    </div>
  </div>
</template>
<script setup>
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import Swal from 'sweetalert2'

const backToClientTop = () => {
  Swal.fire({
    icon: 'question',
    title: 'トップ画面に戻ります。',
    html: 'よろしいですか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then((result) => {
    if (result.isConfirmed) {
      Inertia.get(route('client-examinations'))
      localStorage.clear()
    }
  })
}

const onClickCommentary = () => {
  const examination = JSON.parse(localStorage.getItem('examination')) ?? []
  Inertia.get(route('retry-commentary', {
    examination: examination.examination_id,
    type: examination.examination_type,
  }))
}

window.history.pushState(null, null, null)
window.addEventListener('popstate', () => {
  window.history.pushState(null, null, null)
})
</script>
